import { Component, AfterViewInit, Input, ViewChild } from '@angular/core';
import { Railroad } from 'src/shared/api';
import { BehaviorSubject } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { railroadsFragments } from 'src/admin-app/railroads/railroads.routes';

@Component({
	selector: 'rpfsa-railroad-list',
	templateUrl: './railroad-list.component.html',
	styleUrls: ['./railroad-list.component.css'],
})
export class RailroadListComponent implements AfterViewInit {
	private loading = new BehaviorSubject<boolean>(true);
	loading$ = this.loading.asObservable();

	railroadsFragments = railroadsFragments;

	@Input()
	set railroads(railroads: Railroad[]) {
		if (railroads) {
			this.loading.next(false);
			this.dataSource.data = railroads;
		}
	}

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	emptyColumns = ['empty'];
	resultColumns = [
		'companyName',
		'code',
		'divisionLabel',
		'employerIdentificationNumber',
	];

	dataSource = new MatTableDataSource<Railroad>([]);

	constructor(readonly router: Router) {}

	ngAfterViewInit() {
		this.dataSource.sort = this.sort;
		this.dataSource.paginator = this.paginator;
	}
}
